function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { makeStyles, Typography, Grid, Box } from '@applyboard/ui-components';
import { StyledAccordion, StyledAccordionSummary, StyledAccordionDetails } from "./components/TestAccordion";
import StudentScore from "./components/StudentScore";
import Row from "./components/Row";
import SubHeading from "./components/SubHeading";
import { NotAccepted, NOT_ACCEPTED } from "./components/NotAccepted";
import { formatValue } from "./components/helper";
import { STANDARD_TEST_INPUT_VALUES_DISPLAY } from "../../IneligibleDetails/consts";
import TestName from "./components/TestName";
import RequiredScore from "./components/RequiredScore";
var useStyles = makeStyles({
  rightAlign: {
    textAlign: 'right'
  }
});
var StandardTests = function StandardTests(_ref) {
  var _gmat$t, _gmat$t2, _gmat$t3, _gmat$t4, _gmat$tp, _gmat$tp2, _gmat$tp3, _gmat$tp4, _gmat$q, _gmat$q2, _gmat$q3, _gmat$q4, _gmat$qp, _gmat$qp2, _gmat$qp3, _gmat$qp4, _gmat$w, _gmat$w2, _gmat$w3, _gmat$w4, _gmat$wp, _gmat$wp2, _gmat$wp3, _gmat$wp4, _gmat$v, _gmat$v2, _gmat$v3, _gmat$v4, _gmat$vp, _gmat$vp2, _gmat$vp3, _gmat$vp4, _gre$q, _gre$q2, _gre$q3, _gre$q4, _gre$qp, _gre$qp2, _gre$qp3, _gre$qp4, _gre$w, _gre$w2, _gre$w3, _gre$w4, _gre$wp, _gre$wp2, _gre$wp3, _gre$wp4, _gre$v, _gre$v2, _gre$v3, _gre$v4, _gre$vp, _gre$vp2, _gre$vp3, _gre$vp4;
  var tests = _ref.tests;
  var classes = useStyles();
  var _useState = useState({
      expanded: []
    }),
    _useState2 = _slicedToArray(_useState, 2),
    expandedArr = _useState2[0],
    setExpandedArr = _useState2[1];
  var isComponentScore = function isComponentScore(type, test_name) {
    var _STANDARD_TEST_INPUT_;
    return ((_STANDARD_TEST_INPUT_ = STANDARD_TEST_INPUT_VALUES_DISPLAY[test_name]) === null || _STANDARD_TEST_INPUT_ === void 0 ? void 0 : _STANDARD_TEST_INPUT_.has(type)) && !['t', 'tp'].includes(type);
  };
  var handleChange = function handleChange(panel) {
    return function (event, isExpanded) {
      if (isExpanded) setExpandedArr({
        expanded: [].concat(_toConsumableArray(expandedArr.expanded), [panel])
      });else {
        if (expandedArr.expanded.includes(panel)) setExpandedArr({
          expanded: expandedArr.expanded.filter(function (i) {
            return i !== panel;
          })
        });
      }
    };
  };
  var accepted_tests_list = tests.accepted;
  var selected_tests = tests.selected;
  var showGRE = tests.showGRE,
    showGMAT = tests.showGMAT;

  // format values
  Object.keys(tests).forEach(function (test_name) {
    if (!['gre', 'gmat'].includes(test_name)) return;
    var test = tests[test_name];
    Object.keys(test).forEach(function (score) {
      var student_score_types = STANDARD_TEST_INPUT_VALUES_DISPLAY[test_name];
      if (student_score_types !== null && student_score_types !== void 0 && student_score_types.has(score)) {
        Object.keys(test[score]).forEach(function (score_value) {
          tests[test_name][score][score_value] = formatValue(test[score][score_value]);
        });
      }
    });
  });

  // For accepted tests, show overall score.
  accepted_tests_list.forEach(function (name) {
    var test = tests[name];
    tests[name].subheading = test.t;
  });
  selected_tests.forEach(function (selected_test_name) {
    if (!accepted_tests_list.includes(selected_test_name)) {
      // if student test is not in accepted tests then put Not accepted
      selected_tests.forEach(function (test_name) {
        var selected_test = tests[test_name];
        Object.keys(tests[test_name]).forEach(function (score_type) {
          if (!isComponentScore(score_type, test_name)) {
            tests[test_name].subheading = {
              req: NOT_ACCEPTED,
              student: selected_test[score_type].student,
              pass: null
            };
          }
        });
      });
    } else {
      // if student test is accepted, start by showing the overall score
      // and failed scores if any.
      var test = tests[selected_test_name];
      var req_scores = [test.subheading.req];
      var student_scores = [test.subheading.student];
      Object.keys(test).forEach(function (score_type) {
        if (isComponentScore(score_type, selected_test_name) && !test[score_type].pass) {
          req_scores.push(test[score_type].req);
          student_scores.push(test[score_type].student);
        }
      });
      tests[selected_test_name].subheading = {
        req: req_scores,
        student: student_scores,
        pass: student_scores.length === 1 // only contains overall score
      };
    }
  });
  var test_types = Object.keys(tests);
  var gmat = showGMAT && test_types.includes('gmat') && tests.gmat;
  var gre = showGRE && test_types.includes('gre') && tests.gre;
  var expanded_list = expandedArr.expanded;
  if (gmat) gmat.accepted = accepted_tests_list.includes('gmat');
  if (gre) gre.accepted = accepted_tests_list.includes('gre');
  return /*#__PURE__*/React.createElement(React.Fragment, null, gmat && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(StyledAccordion, {
    onChange: handleChange('gmat'),
    expanded: expanded_list.includes('gmat')
  }, /*#__PURE__*/React.createElement(StyledAccordionSummary, {
    accepted: gmat === null || gmat === void 0 ? void 0 : gmat.accepted
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TestName, null, "GMAT")), gmat.subheading && /*#__PURE__*/React.createElement(SubHeading, {
    expanded: expanded_list.includes('gmat'),
    content: gmat.subheading,
    accepted: gmat.accepted
  }))), /*#__PURE__*/React.createElement(StyledAccordionDetails, {
    accepted: gmat === null || gmat === void 0 ? void 0 : gmat.accepted
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    xs: 12
  }, !gmat.accepted && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(NotAccepted, null)), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, "Total")), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(RequiredScore, null, (_gmat$t = gmat.t) === null || _gmat$t === void 0 ? void 0 : _gmat$t.req)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7,
    className: classes.rightAlign
  }, ((_gmat$t2 = gmat.t) === null || _gmat$t2 === void 0 ? void 0 : _gmat$t2.student) && /*#__PURE__*/React.createElement(StudentScore, {
    pass: (_gmat$t3 = gmat.t) === null || _gmat$t3 === void 0 ? void 0 : _gmat$t3.pass
  }, (_gmat$t4 = gmat.t) === null || _gmat$t4 === void 0 ? void 0 : _gmat$t4.student))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, "Total Rank")), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(RequiredScore, null, (_gmat$tp = gmat.tp) === null || _gmat$tp === void 0 ? void 0 : _gmat$tp.req)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7,
    className: classes.rightAlign
  }, ((_gmat$tp2 = gmat.tp) === null || _gmat$tp2 === void 0 ? void 0 : _gmat$tp2.student) && /*#__PURE__*/React.createElement(StudentScore, {
    pass: (_gmat$tp3 = gmat.tp) === null || _gmat$tp3 === void 0 ? void 0 : _gmat$tp3.pass
  }, (_gmat$tp4 = gmat.tp) === null || _gmat$tp4 === void 0 ? void 0 : _gmat$tp4.student))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, "Quantitative")), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(RequiredScore, null, (_gmat$q = gmat.q) === null || _gmat$q === void 0 ? void 0 : _gmat$q.req)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7,
    className: classes.rightAlign
  }, ((_gmat$q2 = gmat.q) === null || _gmat$q2 === void 0 ? void 0 : _gmat$q2.student) && /*#__PURE__*/React.createElement(StudentScore, {
    pass: (_gmat$q3 = gmat.q) === null || _gmat$q3 === void 0 ? void 0 : _gmat$q3.pass
  }, (_gmat$q4 = gmat.q) === null || _gmat$q4 === void 0 ? void 0 : _gmat$q4.student))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, "Quantitative Rank")), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(RequiredScore, null, (_gmat$qp = gmat.qp) === null || _gmat$qp === void 0 ? void 0 : _gmat$qp.req)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7,
    className: classes.rightAlign
  }, ((_gmat$qp2 = gmat.qp) === null || _gmat$qp2 === void 0 ? void 0 : _gmat$qp2.student) && /*#__PURE__*/React.createElement(StudentScore, {
    pass: (_gmat$qp3 = gmat.qp) === null || _gmat$qp3 === void 0 ? void 0 : _gmat$qp3.pass
  }, (_gmat$qp4 = gmat.qp) === null || _gmat$qp4 === void 0 ? void 0 : _gmat$qp4.student))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, "AWA")), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(RequiredScore, null, (_gmat$w = gmat.w) === null || _gmat$w === void 0 ? void 0 : _gmat$w.req)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7,
    className: classes.rightAlign
  }, ((_gmat$w2 = gmat.w) === null || _gmat$w2 === void 0 ? void 0 : _gmat$w2.student) && /*#__PURE__*/React.createElement(StudentScore, {
    pass: (_gmat$w3 = gmat.w) === null || _gmat$w3 === void 0 ? void 0 : _gmat$w3.pass
  }, (_gmat$w4 = gmat.w) === null || _gmat$w4 === void 0 ? void 0 : _gmat$w4.student))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, "AWA Rank")), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(RequiredScore, null, (_gmat$wp = gmat.wp) === null || _gmat$wp === void 0 ? void 0 : _gmat$wp.req)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7,
    className: classes.rightAlign
  }, ((_gmat$wp2 = gmat.wp) === null || _gmat$wp2 === void 0 ? void 0 : _gmat$wp2.student) && /*#__PURE__*/React.createElement(StudentScore, {
    pass: (_gmat$wp3 = gmat.wp) === null || _gmat$wp3 === void 0 ? void 0 : _gmat$wp3.pass
  }, (_gmat$wp4 = gmat.wp) === null || _gmat$wp4 === void 0 ? void 0 : _gmat$wp4.student))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, "Verbal")), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(RequiredScore, null, (_gmat$v = gmat.v) === null || _gmat$v === void 0 ? void 0 : _gmat$v.req)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7,
    className: classes.rightAlign
  }, ((_gmat$v2 = gmat.v) === null || _gmat$v2 === void 0 ? void 0 : _gmat$v2.student) && /*#__PURE__*/React.createElement(StudentScore, {
    pass: (_gmat$v3 = gmat.v) === null || _gmat$v3 === void 0 ? void 0 : _gmat$v3.pass
  }, (_gmat$v4 = gmat.v) === null || _gmat$v4 === void 0 ? void 0 : _gmat$v4.student))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, "Verbal Rank")), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(RequiredScore, null, (_gmat$vp = gmat.vp) === null || _gmat$vp === void 0 ? void 0 : _gmat$vp.req)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7,
    className: classes.rightAlign
  }, ((_gmat$vp2 = gmat.vp) === null || _gmat$vp2 === void 0 ? void 0 : _gmat$vp2.student) && /*#__PURE__*/React.createElement(StudentScore, {
    pass: (_gmat$vp3 = gmat.vp) === null || _gmat$vp3 === void 0 ? void 0 : _gmat$vp3.pass
  }, (_gmat$vp4 = gmat.vp) === null || _gmat$vp4 === void 0 ? void 0 : _gmat$vp4.student))))))), gre && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(StyledAccordion, {
    onChange: handleChange('gre'),
    expanded: expanded_list.includes('gre')
  }, /*#__PURE__*/React.createElement(StyledAccordionSummary, {
    accepted: gre === null || gre === void 0 ? void 0 : gre.accepted
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TestName, null, "GRE")), gre.subheading && /*#__PURE__*/React.createElement(SubHeading, {
    expanded: expanded_list.includes('gre'),
    content: gre.subheading,
    accepted: gre.accepted
  }))), /*#__PURE__*/React.createElement(StyledAccordionDetails, {
    accepted: gre === null || gre === void 0 ? void 0 : gre.accepted
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    xs: 12
  }, !gre.accepted && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(NotAccepted, null)), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, "Quantitative")), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(RequiredScore, null, (_gre$q = gre.q) === null || _gre$q === void 0 ? void 0 : _gre$q.req)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7,
    className: classes.rightAlign
  }, ((_gre$q2 = gre.q) === null || _gre$q2 === void 0 ? void 0 : _gre$q2.student) && /*#__PURE__*/React.createElement(StudentScore, {
    pass: (_gre$q3 = gre.q) === null || _gre$q3 === void 0 ? void 0 : _gre$q3.pass
  }, (_gre$q4 = gre.q) === null || _gre$q4 === void 0 ? void 0 : _gre$q4.student))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, "Quantitative Rank")), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(RequiredScore, null, (_gre$qp = gre.qp) === null || _gre$qp === void 0 ? void 0 : _gre$qp.req)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7,
    className: classes.rightAlign
  }, ((_gre$qp2 = gre.qp) === null || _gre$qp2 === void 0 ? void 0 : _gre$qp2.student) && /*#__PURE__*/React.createElement(StudentScore, {
    pass: (_gre$qp3 = gre.qp) === null || _gre$qp3 === void 0 ? void 0 : _gre$qp3.pass
  }, (_gre$qp4 = gre.qp) === null || _gre$qp4 === void 0 ? void 0 : _gre$qp4.student))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, "AWA")), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(RequiredScore, null, (_gre$w = gre.w) === null || _gre$w === void 0 ? void 0 : _gre$w.req)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7,
    className: classes.rightAlign
  }, ((_gre$w2 = gre.w) === null || _gre$w2 === void 0 ? void 0 : _gre$w2.student) && /*#__PURE__*/React.createElement(StudentScore, {
    pass: (_gre$w3 = gre.w) === null || _gre$w3 === void 0 ? void 0 : _gre$w3.pass
  }, (_gre$w4 = gre.w) === null || _gre$w4 === void 0 ? void 0 : _gre$w4.student))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, "AWA Rank")), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(RequiredScore, null, (_gre$wp = gre.wp) === null || _gre$wp === void 0 ? void 0 : _gre$wp.req)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7,
    className: classes.rightAlign
  }, ((_gre$wp2 = gre.wp) === null || _gre$wp2 === void 0 ? void 0 : _gre$wp2.student) && /*#__PURE__*/React.createElement(StudentScore, {
    pass: (_gre$wp3 = gre.wp) === null || _gre$wp3 === void 0 ? void 0 : _gre$wp3.pass
  }, (_gre$wp4 = gre.wp) === null || _gre$wp4 === void 0 ? void 0 : _gre$wp4.student))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, "Verbal")), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(RequiredScore, null, (_gre$v = gre.v) === null || _gre$v === void 0 ? void 0 : _gre$v.req)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7,
    className: classes.rightAlign
  }, ((_gre$v2 = gre.v) === null || _gre$v2 === void 0 ? void 0 : _gre$v2.student) && /*#__PURE__*/React.createElement(StudentScore, {
    pass: (_gre$v3 = gre.v) === null || _gre$v3 === void 0 ? void 0 : _gre$v3.pass
  }, (_gre$v4 = gre.v) === null || _gre$v4 === void 0 ? void 0 : _gre$v4.student))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, "Verbal Rank")), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(RequiredScore, null, (_gre$vp = gre.vp) === null || _gre$vp === void 0 ? void 0 : _gre$vp.req)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7,
    className: classes.rightAlign
  }, ((_gre$vp2 = gre.vp) === null || _gre$vp2 === void 0 ? void 0 : _gre$vp2.student) && /*#__PURE__*/React.createElement(StudentScore, {
    pass: (_gre$vp3 = gre.vp) === null || _gre$vp3 === void 0 ? void 0 : _gre$vp3.pass
  }, (_gre$vp4 = gre.vp) === null || _gre$vp4 === void 0 ? void 0 : _gre$vp4.student))))))));
};
export default StandardTests;